module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('BaseInput', {
    attrs: {
      "label": _vm.schema.label
    }
  }, [(_vm.isUploading) ? _vm._l((_vm.uploading), function(upload) {
    return _c('div', {
      key: upload.name,
      staticClass: "file-row",
      staticStyle: {
        "width": "100%"
      }
    }, [_c('div', {
      staticStyle: {
        "flex-basis": "40px"
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "grey"
      }
    }, [_vm._v(_vm._s(_vm.fileIcon(upload.type)))])], 1), _vm._v(" "), _c('div', {
      staticClass: "no-wrap",
      staticStyle: {
        "color": "#888",
        "flex-grow": "1",
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(upload.name.replace(/-.{6}\./, '.')))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "flex-basis": "100px",
        "padding-top": "18px"
      }
    }, [_c('v-progress-linear', {
      model: {
        value: (upload.progress),
        callback: function($$v) {
          _vm.$set(upload, "progress", $$v)
        },
        expression: "upload.progress"
      }
    })], 1)])
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.value), function(file, idx) {
    return _c('div', {
      key: file.name
    }, [_c('DocumentView', {
      attrs: {
        "url": _vm.value[idx].url,
        "type": _vm.value[0].type
      }
    }, [_c('div', {
      staticClass: "file-row",
      class: {
        single: !_vm.schema.multiple
      }
    }, [_c('div', {
      staticStyle: {
        "flex-basis": "40px"
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "grey"
      }
    }, [_vm._v(_vm._s(_vm.fileIcon(file.type)))])], 1), _vm._v(" "), _c('div', {
      staticClass: "no-wrap",
      staticStyle: {
        "color": "#888",
        "flex-grow": "1",
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(file.name.replace(/-.{6}\./, '.')))]), _vm._v(" "), _c('div', [_c('ConfirmIcon', {
      staticStyle: {
        "top": "4px"
      },
      attrs: {
        "small": "",
        "corner": ""
      },
      on: {
        "click": function($event) {
          return _vm.deleteFile(file)
        }
      }
    })], 1)])])], 1)
  }), _vm._v(" "), (_vm.uploaderVisible) ? _c('div', {
    staticClass: "display-flex full-width xxxpt-1"
  }, [_c('div', {
    staticClass: "file-upload",
    class: {
      'has-files': _vm.value && _vm.value.length
    },
    staticStyle: {
      "flex-grow": "1"
    }
  }, [(_vm.linking) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.url),
      expression: "url"
    }],
    ref: "url",
    staticClass: "quick-input",
    staticStyle: {
      "margin": "-3px 0 -4px 0"
    },
    attrs: {
      "placeholder": "https://www.link.com/file  (ESC to Cancel)",
      "type": "text"
    },
    domProps: {
      "value": (_vm.url)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.hideLinking($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.url = $event.target.value
      }
    }
  }) : _c('UploadWrapper', {
    attrs: {
      "multiple": _vm.schema.multiple
    },
    on: {
      "click": function($event) {},
      "select": _vm.uploadFiles
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "grey lighten-1"
    }
  }, [_vm._v("mdi-upload")]), _vm._v("Drag or Click to Upload\n                ")], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "file-upload",
    staticStyle: {
      "flex-basis": "100px",
      "border-left": "solid 1px #ccc",
      "position": "relative"
    },
    on: {
      "click": _vm.link
    }
  }, [(!_vm.linking) ? _c('div', {
    staticClass: "link-or elevation-1"
  }, [_vm._v("OR")]) : _vm._e(), _vm._v("\n                Link\n            ")])]) : _vm._e()], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e7a0eaf0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/forms/controls/FileControl.vue
// module id = 2662
// module chunks = 1